import { useSyncExternalStore } from 'react'

// Each breakpoint has one browser listener, regardless of how many rows,
// avatars, dialogs or navigation components consume it.
function createBreakpointStore(query: string) {
  let media: MediaQueryList | null = null
  const listeners = new Set<() => void>()
  const getMedia = () => (media ??= window.matchMedia(query))
  const notify = () => listeners.forEach(listener => listener())
  const subscribe = (listener: () => void) => {
    const current = getMedia()
    if (listeners.size === 0) current.addEventListener('change', notify)
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
      if (listeners.size === 0) {
        current.removeEventListener('change', notify)
        media = null
      }
    }
  }
  const getSnapshot = () => typeof window !== 'undefined' && getMedia().matches
  const getServerSnapshot = () => false
  return { subscribe, getSnapshot, getServerSnapshot }
}

const mobile = createBreakpointStore('(max-width: 767px)')
const narrow = createBreakpointStore('(max-width: 639px)')

export function useIsMobile() {
  return useSyncExternalStore(
    mobile.subscribe,
    mobile.getSnapshot,
    mobile.getServerSnapshot,
  )
}

// Tailwind's sm breakpoint; independent of the 768px mobile breakpoint.
export function useIsNarrow() {
  return useSyncExternalStore(
    narrow.subscribe,
    narrow.getSnapshot,
    narrow.getServerSnapshot,
  )
}
